import ProductDescription from './ProductDescription'

const BSWholeWheatBagelsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '010',
  IsBroadband: false,
  Size: '',
}

export default BSWholeWheatBagelsProduct
